

<mat-toolbar class="header">
  <div class="back" (click)="goBack()" matTooltip="Atrás" matTooltipPosition="right">
    <mat-icon >arrow_back_ios_new</mat-icon>
  </div>
  <div class="hide-print" style="font-weight: 500;">
   <span class="hide-mobile">{{'order' | human | titlecase}} </span>#{{order()?.correlative_id}}
  </div>
  <div class="expander"></div>
<button mat-button (click)="addChat()" *ngIf="(roleService.can('update','check_in') | async)">
  <mat-icon *ngIf="!addChatLoading()" class="icon-primary">chat</mat-icon>
  <mat-progress-spinner *ngIf="addChatLoading()" diameter="20" mode="indeterminate"></mat-progress-spinner>
</button>
<button mat-button [mat-menu-trigger-for]="menu"><mat-icon>more_horiz</mat-icon></button>
<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="openNotifications()"><mat-icon>notifications</mat-icon> Notificaciones al cliente</button>
  <button mat-menu-item (click)="openChanges()"><mat-icon>fingerprint</mat-icon> Historial de cambios</button>
  <button mat-menu-item (click)="print()"><mat-icon>download</mat-icon> Descargar</button>
  <button mat-menu-item (click)="editMode.set(true)"*ngIf="(roleService.can('update','check_in') | async)"><mat-icon>edit</mat-icon> Editar</button>
  <button
    mat-menu-item
    [appOpenInModal]="ownersList"
    modalTitle="Lista de Miembros"
    [modalConfig]="{width: '80vw'}"
    [modalFooterButtons]="[]"
    >
    <mat-icon>group</mat-icon> Ver Miembros
    <ng-template #ownersList>
      <app-document-owners-list [documentId]="order()?.id" documentType="Order">
      </app-document-owners-list>
    </ng-template>
  </button>
  <button mat-menu-item (click)="addChat()" *ngIf="(roleService.can('update','check_in') | async)"><mat-icon>chat</mat-icon> Agregar al Chat</button>

</mat-menu>

</mat-toolbar>

@if (!order){
  <div class="skeleton-container">
    <div class="skeleton" style="height: 98px;"></div>
    <div class="skeleton" style="height: 123px;"></div>
    <div class="skeleton" style="height: 170px;"></div>
    <div class="skeleton" style="height:  74px;"></div>
    <div class="skeleton" style="height:  90px;"></div>
  </div>
}

<div class="wrapper" #wrapper>
  <div class="check-in-container" *ngIf="editMode() && order()">
    <app-check-in [data]="order()" (saved)="reload()" ></app-check-in>
  </div>

  <div class="order" *ngIf="order() && !editMode()">

    <div class="content">
      <mat-accordion multi>
        <mat-expansion-panel disabled class="expansion-title">
          <mat-expansion-panel-header>
              <div class="panel-title">
                General
              </div>
          </mat-expansion-panel-header>

        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <div class="panel-title">
              <mat-icon>engineering</mat-icon>
              {{order()?.location?.name}} - {{order().user?.name || 'Sin recepcionista'}}
            </div>
          </mat-expansion-panel-header>
          <div class="info">
            <div class="name">{{ 'location' | human }}</div>
            <div class="value">{{order()?.location?.name}}</div>

            <div class="name">Recepcionista</div>
            <div class="value">{{order().user?.name}}</div>

            <div class="name">Teléfono</div>
            <div class="value">{{order().user?.phone || '-'}}</div>

            <div class="name">Recepción</div>
            <div class="value">{{(order().check_in_time | date:'medium') || '-' }}</div>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <div class="panel-title">
              <mat-icon>person</mat-icon>
              <div>{{(order().client?.name | titlecase | truncate: ["30"]) || ('client' | human)}}</div>
              <i class="panel-subtitle">{{order().client?.rut | identifier}}</i>
              <span class="hide-mobile"><app-stars [stars]="order().client?.rating"></app-stars></span>
            </div>
          </mat-expansion-panel-header>
          
          <div class="info">
            <div class="name">{{('client' | human)}}</div>
            <div class="value">{{(order().client?.name | titlecase) || 'No existe el' + ('client' | human | lowercase)}}</div>
            @if (roleService.can('read','client') | async) {
              <div class="name">{{company.country.preferences.client_id}}</div>
              <div class="value">{{order().client?.rut | identifier}}</div>
              <div class="name">Dirección</div>
              <div class="value">{{order().client?.address}}, {{order().client?.city}}</div>
              <div class="name">E-mail</div>
              <div class="value">{{order().client?.email}}</div>
              <div class="name">Teléfono</div>
              <div class="value"><a href="tel:{{order().client?.phone}}" class="phone"><i class="fa fa-phone"></i>{{order().client?.phone}}</a></div>
              <div class="name">Categoría</div>
              <div class="value"><app-stars [stars]="order().client?.rating"></app-stars></div>
            }
          </div>
          <br />
          @if (roleService.can('read','client') | async) {
            <app-order-fields [readonly]="true" [model]="order().client" mode='Client' [wrap]="true"></app-order-fields>
          }
        </mat-expansion-panel>
        

        <mat-expansion-panel *ngIf="company.object === 'Vehicle'">
          <mat-expansion-panel-header>
            <div class="panel-title">
              <mat-icon>directions_car</mat-icon>
              {{order().object?.brand?.name}} {{order().object?.brand_model?.name}}
              <i class="panel-subtitle">#{{order().object?.identifier || order().object_id}}</i>
            </div>
          </mat-expansion-panel-header>
          <div class="info">
            <div class="name">{{ 'object_identifier' | human}}</div>
            <div class="value">{{order().object?.identifier}}</div>
            <div class="name">Marca</div>
            <div class="value">{{order().object?.brand?.name}}</div>
            <div class="name">Modelo</div>
            <div class="value">{{order().object?.brand_model?.name}}</div>
            <div class="name">Chasis</div>
            <div class="value">{{order().object?.chasis || '-'}}</div>
            <div class="name">Año</div>
            <div class="value">{{order().object?.year || '-'}}</div>
            <div class="name">Kilometraje</div>
            <div class="value">{{order().kms || order().object?.kms}}</div>
            <div class="name">Color</div>
            <div class="value">{{order().object?.color}}</div>
          </div>
          <br />
          <app-order-fields [readonly]="true" [model]="order().object" mode='Vehicle' [wrap]="true"></app-order-fields>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="company.object === 'Custom'">
          <mat-expansion-panel-header>
            <div class="panel-title">
              <mat-icon>category</mat-icon>
              {{ 'object' | human }} #{{order().object_id}}
            </div>
          </mat-expansion-panel-header>
          <div class="info">
            <div class="name">{{ 'object_identifier' | human }}</div>
            <div class="value">{{order().object?.identifier}}</div>
          </div>
          <br />
          <app-order-fields [readonly]="true" [model]="order().object" mode='Custom' [wrap]="true"></app-order-fields>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <div class="panel-title">
              <mat-icon>build</mat-icon>
              {{order().requirement?.name}}<i class="panel-subtitle">{{order().comment | truncate: ["30"]}}</i>
            </div>
          </mat-expansion-panel-header>
          <div class="info">
            <div class="name">{{ 'requirement' | human }}</div>
            <div class="value">{{order().requirement?.name}}</div>
            <div class="name">{{ 'comment' | human }}</div>
            <div class="value">{{order().comment}}</div>
            <div class="name hide-print">Finalización</div>
            <div class="value hide-print" *ngIf="!order().finish_date && !order().completed_at">Sin fecha agendada</div>
            <div class="value hide-print" *ngIf="order().finish_date && !order().completed_at">Agendada al {{order().finish_date | date:'short'}}</div>
            <div class="value hide-print" *ngIf="order().completed_at">Finalizada el {{order().completed_at | date:'short'}}</div>
            @if (order().sign_url) {
              <div class="name hide-print">Firma</div>
              <div class="value hide-print"><img src="{{order().sign_url}}" style="max-height: 100px"/></div>
            }
          </div>
          <br />
          <app-order-fields [readonly]="true" [model]="order()"></app-order-fields>
          <br />
          <div *ngIf="order().order_aditionals.length > 0">
            <div class="subtitle">{{'aditional' | human: 'capitalize': null: 'plural'}}</div>
            <div class="aditionals-form">
              <app-additionals-form
                class="aditionals"
                [initialValue]="order().order_aditionals"
                [readonly]="true"
              >
              </app-additionals-form>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      @if(order().requirement) {
        <mat-accordion multi style="margin-top: 20px;">
          <mat-expansion-panel disabled class="expansion-title">
            <mat-expansion-panel-header>
                <div class="panel-title">
                  Detalle de Productos
                </div>
            </mat-expansion-panel-header>
  
          </mat-expansion-panel>
          <mat-expansion-panel class="expansion-panel">
            <mat-expansion-panel-header>
                <div class="panel-title">
                  <mat-icon>attach_money</mat-icon>
                  {{order().requirement.name}} &nbsp; <span>({{(requirementTotal) | money  }})</span>
                </div>
            </mat-expansion-panel-header>
            <div class="info statement">
              @for (item of order().inventory_action_for_consume?.inventory_action_products; track item.id) {
                <div class="quantity right">{{item.quantity || 1}}</div>
                <div class="value">{{item.product.code}} - {{item.product.name}} </div>
                <div class="total">{{item.amount * item.quantity | money }}</div>
              }
              <div class="quantity"></div> 
              <div class="value highlight">Neto</div>
              <div class="total highlight" style="text-align: right">{{order().inventory_action_for_consume?.total | money }}</div>
              <div class="quantity"></div>
              <div class="value highlight">{{ 'tax' | human: 'uppercase': 'IVA' }}</div>
              <div class="total highlight" style="text-align: right">{{order().inventory_action_for_consume?.total * 0.19 | money }}</div>
              <div class="quantity"></div>
              <div class="value highlight">Total</div>
              <div class="total highlight" style="text-align: right">{{order().inventory_action_for_consume?.total * 1.19 | money }}</div>
            </div>
          </mat-expansion-panel>

          @for(budget of order().budgets; track budget.correlative_id){
            <mat-expansion-panel class="expansion-panel">
              <mat-expansion-panel-header>
                  <div class="panel-title">
                    <mat-icon>attach_money</mat-icon>
                    {{'budget' | human | titlecase}} Nº {{budget.correlative_id}} &nbsp; <span>({{(budget.total * 1.19 | money)}})</span>
                  </div>
              </mat-expansion-panel-header>
              <div class="info statement">
                @for(item of budgetItems(budget); track item.id) {
                  @if (item.amount !=0){
                    <div class="quantity right">{{item.quantity || 1}}</div>
                    <div class="value inline">{{item.product.code}} - {{item.product.name}}</div>
                    <div class="total">{{item.quantity * item.amount * (1 - item.discount_percent / 100) | money}}</div>
                  }
                }

                <div class="quantity"></div>
                <div class="value highlight">Neto</div>
                <div class="total highlight" style="text-align: right">{{budget.total | money }}</div>

                <div class="quantity"></div>
                <div class="value highlight">{{ 'tax' | human: 'uppercase': 'IVA' }}</div>
                <div class="total highlight" style="text-align: right">{{budget.total * 0.19 | money }}</div>

                <div class="quantity"></div>
                <div class="value highlight">Total</div>
                <div class="total highlight" style="text-align: right">{{budget.total * 1.19 | money }}</div>
              </div>
              <div class="budget-buttons">
                <button mat-button class="primary" (click)="openBudget(budget.id)">Ver  {{ 'budget' | human | titlecase }}</button>
              </div>
            </mat-expansion-panel>
          }

          <mat-expansion-panel disabled>
            <mat-expansion-panel-header>
                <div class="panel-title">
                  <mat-icon>attach_money</mat-icon>
                 Total: {{getOrderTotal() | money }}
                </div>
            </mat-expansion-panel-header>

          </mat-expansion-panel>
        </mat-accordion>
      }
      <br>

      <mat-accordion multi >
        <mat-expansion-panel disabled class="expansion-title">
          <mat-expansion-panel-header>
              <div class="panel-title">
                Documentos Adjuntos
              </div>
          </mat-expansion-panel-header>

        </mat-expansion-panel>
        <mat-expansion-panel class="expansion-panel">
          <mat-expansion-panel-header>
              <div class="panel-title">
                <mat-icon>request_quote</mat-icon>
                {{ 'inventory_action/pricing' | human: null: null: 'plural' | titlecase }} &nbsp; <span>({{order()?.pricings?.length || 0}})</span>
              </div>
          </mat-expansion-panel-header>
          <mat-accordion multi >
            @for (pricing of order().pricings; track pricing.id) {
              <mat-expansion-panel class="expansion-panel">
                <mat-expansion-panel-header>
                    <div class="panel-title">
                      <mat-icon>request_quote</mat-icon>
                      {{ 'inventory_action/pricing' | human | titlecase }} Nº <span>{{pricing.correlative_id}}</span>
                    </div>
                </mat-expansion-panel-header>

                <div class="info">
                  <div class="name">Proveedor:</div><div class="value">{{ pricing.owner.name }}</div>
                  <div class="name">Estado:</div><div class="value">{{ pricing.status?.name }}</div>
                  <div class="name">Respondida:</div><div class="value">{{ pricing.draft ? 'No' : 'Si' }}</div>
                </div>
                <br />
                <div class="info">
                  @for(item of pricing.extra_params.required_products; track item.product_id) {
                    @if (item.quantity != 0){
                      <div class="quantity right">{{item.quantity}}</div>
                      <div class="value inline">{{item.product?.code}} - {{item.product?.name}}</div>
                    }
                  }
                </div>

                <div class="budget-buttons">
                  <button
                    mat-button
                    class="primary"
                    go-to-details
                    [element]="pricing"
                  >Ver {{ 'inventory_action/pricing' | human | titlecase }}</button>
                  @if (pricing.folder_id) {
                    <button
                      mat-button
                      class="primary"
                      go-to-details
                      [element]="{id: pricing.folder_id, type: 'Folder::InventoryAction::Pricing'}"
                    >Ver {{ 'folder/inventory_action/pricing' | human | titlecase }}</button>
                  }
                </div>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansion-panel">
          <mat-expansion-panel-header>
              <div class="panel-title">
                <mat-icon>list_alt</mat-icon>
                {{ 'inventory_action/buy_order' | human: null: null: 'plural' | titlecase }} &nbsp; <span>({{order()?.buy_orders?.length || 0}})</span>
              </div>
          </mat-expansion-panel-header>
          <mat-accordion multi >
            @for (buy_order of order().buy_orders; track buy_order.id) {
              <mat-expansion-panel class="expansion-panel">
                <mat-expansion-panel-header>
                    <div class="panel-title">
                      <mat-icon>list_alt</mat-icon>
                      {{ 'inventory_action/buy_order' | human | titlecase }} Nº <span>{{buy_order.correlative_id}}</span>
                    </div>
                </mat-expansion-panel-header>

                <div class="info">
                  <div class="name">Proveedor:</div><div class="value">{{ buy_order.owner.name }}</div>
                  <div class="name">Estado:</div><div class="value">{{ buy_order.status?.name }}</div>
                  <div class="name">Respondida:</div><div class="value">{{ buy_order.draft ? 'No' : 'Si' }}</div>
                </div>
                <br />


                <div class="info">
                  @for(item of buy_order.inventory_action_products; track item.product_id) {
                    @if (item.quantity != 0){
                      <div class="quantity right">{{item.quantity}}</div>
                      <div class="value inline">{{item.product?.code}} - {{item.product?.name}}</div>
                    }
                  }
                </div>

                <div class="budget-buttons">
                  <button
                    mat-button
                    class="primary"
                    go-to-details
                    [element]="buy_order"
                  >Ver {{ 'inventory_action/buy_order' | human | titlecase }}</button>
                </div>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </mat-expansion-panel>

        <mat-expansion-panel class="expansion-panel">
          <mat-expansion-panel-header>
              <div class="panel-title">
                <mat-icon>description</mat-icon>
                {{ 'invoice/sale_plural' | human | titlecase }} &nbsp; <span>({{order()?.invoices?.length || 0}})</span>
              </div>
          </mat-expansion-panel-header>
          <mat-accordion multi >
            @for (invoice of order().invoices; track invoice.id) {
              <mat-expansion-panel class="expansion-panel">
                <mat-expansion-panel-header>
                    <div class="panel-title">
                      <mat-icon>request_quote</mat-icon>
                      {{ invoice.invoice_type | human | titlecase }} Nº <span>{{invoice.correlative_id}}</span>
                    </div>
                </mat-expansion-panel-header>

                <div class="info">
                  <div class="name">{{ invoice.stakeholder_type | human }}:</div><div class="value">{{ invoice.stakeholder.name }}</div>
                  <div class="name">Fecha Emision:</div><div class="value">{{ invoice.created_at | date }}</div>
                  <div class="name">Fecha de Pago:</div><div class="value">{{ invoice.due_date | date }}</div>
                  <div class="name">Método de Pago:</div><div class="value">{{ invoice.data?.payment?.payment_method | human }}</div>
                  <div class="name">Monto Pagado:</div><div class="value">{{ invoice.data?.payment?.amount | money }}</div>
                </div>

                <br />

                <div class="info">
                  @for(item of invoice.data.details; track item) {
                    @if (item.quantity != 0){
                      <div class="quantity right">{{item.quantity}}</div>
                      <div class="value inline">{{item.product?.code}} - {{item.product?.name}}</div>
                    }
                  }
                </div>

                <div class="budget-buttons">
                  @if (invoice.url) {
                    <a
                      mat-button
                      href="{{ invoice.url }}"
                      target="_blank"
                      class="primary"
                    >Ver {{ invoice.invoice_type | human | titlecase }}</a>
                  } @else {
                    <button
                      mat-button
                      class="primary"
                      go-to-details
                      [element]="invoice"
                    >Ver {{ invoice.invoice_type | human | titlecase }}</button>
                  }
                </div>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </mat-expansion-panel>

                
        @if ((order().order_attachments && order().order_attachments.length > 0) || (order().pictures && order().pictures.length > 0)) {
          <mat-expansion-panel class="expansion-panel">
            <mat-expansion-panel-header>
                <div class="panel-title">
                  <mat-icon>photo_camera</mat-icon>
                  Imagenes&nbsp;<span>({{(order().order_attachments?.length || 0) + (order().pictures?.length || 0)}})</span>
                </div>
            </mat-expansion-panel-header>
            <div class="subtitle subtitle-images" *ngIf="order().order_attachments && order().order_attachments.length > 0">Imagenes Pre-trabajo</div>
            <app-image-uploader class="hide-print" [photos]="order().order_attachments" [readonly]="true" [scrollTarget]="wrapper" *ngIf="order().order_attachments && order().order_attachments.length > 0" ></app-image-uploader>
            <div class="subtitle subtitle-images" *ngIf="order().pictures && order().pictures.length > 0">Imagenes de Trabajos</div>
            <app-image-uploader [photos]="order().pictures" [readonly]="true" [scrollTarget]="wrapper" *ngIf="order().pictures && order().pictures.length > 0" ></app-image-uploader>
          </mat-expansion-panel>
        }

        <mat-expansion-panel class="hide-print order-expansion-panel-works expansion-panel">
          <mat-expansion-panel-header>
              <div class="panel-title">
                <mat-icon>build_circle</mat-icon>
                Trabajos&nbsp;<span>({{order().works?.length || 0}})</span>
              </div>
          </mat-expansion-panel-header>
          <app-document-works [order]="order()" class="hide-print" (load)="load()"></app-document-works>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div class="legend only-print">
      {{company.preferences.order_legend}}
      <ng-container *ngIf="!company.preferences.order_legend">
        Autorizo todas las reparaciones aquí detalladas, el uso, traslado e instalación de piezas que se requiera para ello.

        {{company.name}} queda autorizado para efectuar las pruebas que sean necesarias fuera del servicio, tanto en calles como carreteras.

        {{company.name}} realizará reparaciones de acuerdo a lo autorizado por la compañía de seguros. Toda reparación no efectuada deberá atenderse de forma externa entre el asegurado y respectivo liquidador.{{company.name}} no se responsabiliza por objetos no declarados al momento de la recepción del vehículo.

        {{company.name}} por todo vehículo que no sea retirado dentro de 48 horas de finalizada la reparación, cobrará el respectivo almacenaje.
      </ng-container>
    </div>
    <div class="signature">
      <div class="placeholder" [style.background-image]="sanitizeBackground(order().sign_url)">
        <div class="sign"></div>
        <span>Firma Cliente</span>
      </div>
    </div>
  </div>
  <div class="no-access" *ngIf="forbidden()">
    <i class="fa fa-warning"></i>
    No tienes acceso a esta información
  </div>
</div>


<mat-toolbar *ngIf="order() && !editMode()" class="footer">
  <div class="buttons">
    <app-work-request-button
      [id]="order().id"
      [document]="order()"
      type="Order"
      [status_id]="order().status_id"
      [allowedDocumentsForCreation]="allowedDocumentsForCreation()"
      (afterDialogClose)="reload()"
    >
    </app-work-request-button>
    
    <div class="expander"></div>
    <button mat-raised-button class="primary" [matMenuTriggerFor]="menu" [disabled]="updatingOrder()" *ngIf="(roleService.can('update','check_in') | async)">
      @if(updatingOrder()){
        <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
      }@else{
        <i class="fa fa-pencil-alt"></i>
      }
      <span class="hide-mobile">{{order().status_id | status}}</span>
    </button>
    <mat-menu #menu="matMenu">
      @for (status of statuses; track status.id) {
        <button
          mat-menu-item
          (click)="setStatus(status.id)"
          [style.color]="status.color"
          [disabled]="updatingOrder() || status.id === order().status_id"
          matTooltip="Estado actual"
          [matTooltipDisabled]="status.id !== order().status_id"
        >
          <span>{{status.name}}</span>
          @if (status.id === order().status_id) {
            &nbsp;
            <div class="fa fa-check"></div>
          }
        </button>

      }

    </mat-menu>
  </div>
</mat-toolbar>
